import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'

interface TextProps {
  component: Component
  locale: LocaleCode
  style: React.CSSProperties
}

export function Text({ component, locale, style }: TextProps) {
  const config = component.config as any
  const content = getLocalizedText(config.content, locale)

  return <p style={style}>{content}</p>
}
